import type { IPackage } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import type { CardStatus } from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/utils/consts";

const getCurrentRewardIndex = (packages: IPackage[], currentProgress: number) => {
    for (let i = packages.length - 1; i >= 0; i--) {
        if (currentProgress >= packages[i].ReferralsNumber) {
            return i;
        }
    }

    return -1;
};

export const getCardStatus = (index: number, packages: IPackage[], currentProgress: number): CardStatus => {
    const highestClaimableIndex = getCurrentRewardIndex(packages, currentProgress);
    if (index === highestClaimableIndex) {
        return "claimed";
    }

    const requiredReferrals = packages[index].ReferralsNumber;
    const hasEnoughReferrals = currentProgress >= requiredReferrals;

    if (hasEnoughReferrals && index < highestClaimableIndex) {
        return "disabled";
    }

    return "open";
};
